import React from 'react'
import { Link } from 'react-router-dom'
import { url } from '../../Config/Config'
import image from "../../assets/images/bg.jpg"
import { FormattedMessage } from 'react-intl'

function PageNotFound() {
  return (

    // <div className="pageNOtFOund" style={{ backgroundImage: `url(${image }})` }}>
  <div className="pageNOtFOund"> 

      <div>
        <h1>404</h1>
        <h2><FormattedMessage id="page_not_found" /></h2>
        <p className="h5"><FormattedMessage id="page_not_found_desc" /></p>
        <Link to={url + '/dashboard'} className='btn btn-primary mt-5'><FormattedMessage id="go_back" /></Link>
      </div>
    </div >

  )

}

export default PageNotFound
